(() => {
  const menu = document.querySelector('[data-menu]');
  const navigation = document.getElementById('navigation');
  const compactHeader = matchMedia('(max-width: 1199px)');
  const setMenu = (open, restoreFocus = false) => {
    if (!menu || !navigation) return;
    menu.setAttribute('aria-expanded', String(open));
    navigation.classList.toggle('open', open);
    if (restoreFocus) menu.focus();
  };
  menu?.addEventListener('click', () => setMenu(menu.getAttribute('aria-expanded') !== 'true'));
  navigation?.addEventListener('click', event => { if (event.target.closest('a')) setMenu(false); });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && menu?.getAttribute('aria-expanded') === 'true') setMenu(false, true);
  });
  document.addEventListener('pointerdown', event => {
    if (menu?.getAttribute('aria-expanded') === 'true' && !event.target.closest('.header')) setMenu(false);
  });
  compactHeader.addEventListener('change', () => setMenu(false));

  const photo = document.querySelector('[data-main-photo]');
  document.querySelectorAll('[data-thumb]').forEach(button => button.addEventListener('click', () => {
    if (!photo) return;
    photo.src = button.dataset.thumb;
    photo.srcset = button.dataset.srcset || '';
    photo.alt = button.querySelector('img').alt;
    photo.width = Number(button.dataset.width);
    photo.height = Number(button.dataset.height);
    const caption = document.querySelector('[data-photo-caption]');
    if (caption) caption.textContent = button.dataset.caption || '';
    document.querySelectorAll('[data-thumb]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
  }));

  const zoom = document.querySelector('[data-zoom-dialog]');
  const zoomTrigger = document.querySelector('[data-zoom]');
  let previousOverflow = '';
  zoomTrigger?.addEventListener('click', () => {
    if (!zoom || !photo || typeof zoom.showModal !== 'function') return;
    zoom.querySelector('img').src = photo.src;
    zoom.querySelector('img').alt = photo.alt;
    previousOverflow = document.documentElement.style.overflow;
    zoom.showModal();
    document.documentElement.style.overflow = 'hidden';
  });
  zoom?.querySelector('button').addEventListener('click', () => zoom.close());
  zoom?.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow;
    zoomTrigger?.focus({ preventScroll: true });
  });
  zoom?.addEventListener('click', event => {
    if (event.target !== zoom) return;
    const rect = zoom.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) zoom.close();
  });

  document.querySelectorAll('[data-quantity-control]').forEach(control => {
    const input = control.querySelector('input');
    const decrease = control.querySelector('[data-quantity-step="-1"]');
    const increase = control.querySelector('[data-quantity-step="1"]');
    const sync = () => {
      const current = Number(input.value);
      const minimum = Number(input.min) || 0;
      const maximum = input.max === '' ? Infinity : Number(input.max);
      decrease.disabled = input.value !== '' && current <= minimum;
      increase.disabled = current >= maximum;
    };
    control.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click', () => {
      const step = Number(input.step) || 1;
      const minimum = Number(input.min) || 0;
      const maximum = input.max === '' ? Infinity : Number(input.max);
      const current = Number.parseInt(input.value, 10) || minimum;
      input.value = String(Math.max(minimum, Math.min(maximum, current + Number(button.dataset.quantityStep) * step)));
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    input.addEventListener('input', sync);
    sync();
  });

  document.querySelectorAll('[data-variant]').forEach(select => select.addEventListener('change', () => {
    const option = select.selectedOptions[0];
    document.querySelectorAll('[data-add]').forEach(button => {
      button.disabled = option.dataset.available !== 'true';
      button.textContent = button.disabled ? button.dataset.sold : button.dataset.ready;
    });
    document.querySelectorAll('[data-price]').forEach(price => price.textContent = option.dataset.price);
    if (photo && option.dataset.image) {
      photo.srcset = '';
      photo.src = option.dataset.image;
    }
  }));

  const purchase = document.getElementById('PurchaseForm');
  purchase?.addEventListener('submit', event => {
    const button = purchase.querySelector('[data-add]');
    if (event.submitter !== button) return;
    if (purchase.dataset.submitting === 'true') { event.preventDefault(); return; }
    purchase.dataset.submitting = 'true';
    button.setAttribute('aria-busy', 'true');
    button.textContent = button.dataset.adding;
  });
  window.addEventListener('pageshow', () => {
    const button = purchase?.querySelector('[data-add]');
    if (!button) return;
    delete purchase.dataset.submitting;
    button.removeAttribute('aria-busy');
    button.textContent = button.disabled ? button.dataset.sold : button.dataset.ready;
  });
  const cartForm = document.querySelector('[data-cart-form]');
  cartForm?.addEventListener('input', event => {
    if (event.target.name !== 'updates[]') return;
    cartForm.querySelector('[data-cart-status]').hidden = false;
  });
})();

(() => {
  const namespace = 'http://www.w3.org/2000/svg';
  const lightColor = '#f2f7ff';
  const cycle = 10000;
  const covers = [
    {
      file: 'led-express-signature-hex-kit-ram-trx.png',
      kind: 'pickup',
      ceiling: '22,300 737,300 628,505 454,505 428,479 379,468 325,466 279,471 225,487 192,505 113,505',
      headlights: ['370,550 452,552 451,572 428,577 373,573', '605,558 621,562 623,586 615,589 604,578']
    },
    {
      file: '471beac5-3c18-4395-b79f-b1243792f709.png',
      kind: 'suspended',
      ceiling: '23,320 725,320 629,510 445,510 422,491 370,480 307,478 293,505 120,510',
      headlights: []
    }
  ];
  let sequence = 0;
  const setPhase = host => {
    const now = Date.now();
    host.style.setProperty('--le-light-phase', `-${(now % cycle) / 1000}s`);
    host.style.setProperty('--le-hazard-phase', `-${(now % 1350) / 1000}s`);
  };
  const visibility = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) setPhase(entry.target);
      entry.target.classList.toggle('le-photo-glow-visible', entry.isIntersecting);
    });
  }, { rootMargin: '100px' }) : null;
  const haloFilter = (id, blur, strength) =>
    `<filter id="${id}" filterUnits="userSpaceOnUse" x="0" y="270" width="750" height="270" color-interpolation-filters="sRGB"><feGaussianBlur stdDeviation="${blur}"/><feComponentTransfer><feFuncA type="linear" slope="${strength}"/></feComponentTransfer></filter>`;
  const lampFilter = id =>
    `<filter id="${id}" filterUnits="userSpaceOnUse" x="350" y="530" width="295" height="85" color-interpolation-filters="sRGB"><feColorMatrix type="matrix" values="0 0 0 0 .94902 0 0 0 0 .96863 0 0 0 0 1 .2126 .7152 .0722 0 0"/><feComponentTransfer result="cores"><feFuncA type="linear" slope="7" intercept="-3.8"/></feComponentTransfer><feGaussianBlur in="cores" stdDeviation="9" result="halo"/><feMerge><feMergeNode in="halo"/><feMergeNode in="halo"/><feMergeNode in="cores"/></feMerge></filter>`;
  const vehicleEffects = (id, kind) => {
    if (kind === 'pickup') {
      const markers = [
        '373,557 380,557 380,565 373,565',
        '514,541 522,541 523,545 515,545',
        '538,542 546,543 547,547 539,547',
        '560,544 568,545 569,548 561,548',
        '352,606 362,606 364,609 353,609',
        '623,589 625,589 626,594 623,593',
        '233,516 251,516 254,521 232,521'
      ].map(points => `<polygon points="${points}"/>`).join('');
      return `<defs><filter id="${id}-amber" filterUnits="userSpaceOnUse" x="215" y="495" width="430" height="135" color-interpolation-filters="sRGB"><feGaussianBlur in="SourceGraphic" stdDeviation="4" result="halo"/><feMerge><feMergeNode in="halo"/><feMergeNode in="halo"/><feMergeNode in="SourceGraphic"/></feMerge></filter></defs><g class="le-truck-marker-lenses" fill="#362b20" opacity=".78">${markers}</g><g class="le-truck-hazards"><g fill="#ff9800" filter="url(#${id}-amber)">${markers}</g><g fill="#ffd18a">${markers}</g></g>`;
    }
    return `<defs><filter id="${id}-exhaust" filterUnits="userSpaceOnUse" x="-125" y="-65" width="145" height="100" color-interpolation-filters="sRGB"><feGaussianBlur stdDeviation="1.8"/></filter></defs><g class="le-bike-exhaust" transform="translate(183 585)" fill="#cbd4db"><g filter="url(#${id}-exhaust)"><path class="le-bike-exhaust-puff" d="M0-1 C-6-4-12-3-17-2 C-23 0-26-4-31-2 C-38 0-34 4-28 3 C-22 5-20 2-15 3 C-10 5-6 2 0 2 Z"/><path class="le-bike-exhaust-puff" d="M0-1 C-6-3-10-5-16-2 C-20 1-28-3-32 0 C-36 3-27 5-23 3 C-18 2-16 5-10 3 C-5 1-3 3 0 1 Z"/><path class="le-bike-exhaust-puff" d="M0-1 C-5-4-10-1-15-3 C-22-5-25 0-31-1 C-36-1-33 4-28 4 C-22 2-20 6-14 3 C-8 1-4 4 0 2 Z"/></g></g>`;
  };
  const attach = image => {
    if (image.dataset.leGlowBound === 'true') return;
    image.dataset.leGlowBound = 'true';
    const host = image.parentElement;
    let overlay = null;
    let activeKind = '';
    let activeSource = '';
    const clear = () => {
      overlay?.remove();
      overlay = null;
      activeKind = '';
      activeSource = '';
      host.classList.remove('le-photo-glow-host', 'le-photo-glow-visible');
      host.style.removeProperty('--le-light-phase');
      host.style.removeProperty('--le-hazard-phase');
      visibility?.unobserve(host);
    };
    const update = () => {
      const requested = (image.getAttribute('src') || '').toLowerCase();
      const cover = covers.find(item => requested.includes(item.file));
      const source = image.currentSrc || image.src;
      if (!cover || !image.complete || !image.naturalWidth || !source.toLowerCase().includes(cover.file)) {
        clear();
        return;
      }
      if (!overlay || activeKind !== cover.kind) {
        clear();
        const id = `le-cover-glow-${++sequence}`;
        overlay = document.createElementNS(namespace, 'svg');
        overlay.setAttribute('viewBox', '0 0 750 937');
        overlay.setAttribute('preserveAspectRatio', 'none');
        overlay.setAttribute('aria-hidden', 'true');
        overlay.setAttribute('focusable', 'false');
        overlay.setAttribute('class', 'le-photo-glow');
        overlay.dataset.glowKind = cover.kind;
        overlay.dataset.glowColor = lightColor;
        overlay.dataset.glowBrightness = 'matched';
        const lamps = cover.headlights.map(points => `<polygon points="${points}"/>`).join('');
        overlay.innerHTML = `<defs><clipPath id="${id}-ceiling"><polygon points="${cover.ceiling}"/></clipPath><filter id="${id}-mask" filterUnits="userSpaceOnUse" x="0" y="285" width="750" height="240" color-interpolation-filters="sRGB"><feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 .2126 .7152 .0722 0 0"/><feComponentTransfer><feFuncA type="linear" slope="20" intercept="-13.3"/></feComponentTransfer></filter><mask id="${id}-tubes" maskUnits="userSpaceOnUse" maskContentUnits="userSpaceOnUse" x="0" y="285" width="750" height="240" style="mask-type:alpha"><g filter="url(#${id}-mask)"><g clip-path="url(#${id}-ceiling)"><image width="750" height="937" preserveAspectRatio="none"/></g></g></mask>${haloFilter(`${id}-steady`, 5, 1.6)}${haloFilter(`${id}-pulse`, 10, 4)}<linearGradient id="${id}-sweep"><stop offset="0" stop-color="${lightColor}" stop-opacity="0"/><stop offset=".3" stop-color="${lightColor}" stop-opacity=".45"/><stop offset=".5" stop-color="${lightColor}" stop-opacity="1"/><stop offset=".7" stop-color="${lightColor}" stop-opacity=".45"/><stop offset="1" stop-color="${lightColor}" stop-opacity="0"/></linearGradient>${lamps ? `<clipPath id="${id}-lamps">${lamps}</clipPath>${lampFilter(`${id}-headlight`)}` : ''}</defs><g class="le-photo-steady" filter="url(#${id}-steady)"><g mask="url(#${id}-tubes)"><rect x="0" y="285" width="750" height="240" fill="${lightColor}"/></g></g><g mask="url(#${id}-tubes)"><rect x="0" y="285" width="750" height="240" fill="${lightColor}"/></g><g class="le-photo-pulse" filter="url(#${id}-pulse)"><g mask="url(#${id}-tubes)"><rect class="le-photo-sweep" x="0" y="285" width="260" height="240" fill="url(#${id}-sweep)"/></g></g>${lamps ? `<g class="le-photo-lamps" filter="url(#${id}-headlight)"><g clip-path="url(#${id}-lamps)"><image width="750" height="937" preserveAspectRatio="none"/></g></g>` : ''}`;
        overlay.insertAdjacentHTML('beforeend', vehicleEffects(id, cover.kind));
        host.classList.add('le-photo-glow-host');
        host.append(overlay);
        activeKind = cover.kind;
        if (visibility) visibility.observe(host);
        else {
          setPhase(host);
          host.classList.add('le-photo-glow-visible');
        }
      }
      if (activeSource !== source) {
        overlay.querySelectorAll('image').forEach(layer => layer.setAttribute('href', source));
        activeSource = source;
      }
    };
    image.addEventListener('load', update);
    image.addEventListener('error', clear);
    new MutationObserver(update).observe(image, { attributes: true, attributeFilter: ['src', 'srcset'] });
    update();
  };
  const scan = root => root.querySelectorAll('.le-kit-image > img, [data-main-photo]').forEach(attach);
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
